export default __webpack_public_path__ + "locales/it/ArchiveDialog.json?hash=8c884ace1d0c9a69b3384aedefbb33d1";